
import { Vue, Component, Prop } from "vue-property-decorator";
import Model from "./model";
import MenuComponents from "@/components/menu.vue";
import PageComponents from "@/components/page.vue";
import Common from "../../commonUtil/common";

// 必须使用@Component注解
@Component({
  components: {
    MenuComponents,
    PageComponents,
  },
})
export default class PersonValVue extends Vue {
  private model = new Model();
  private common = new Common();

  private form: any = {
    title: '',
    name: '',
    type: '',
    typeName: '',
    typeValue: '',
  };

  private tableData: any = null;

  // 功能名称
  private funName: any = "";

  // 新建窗口是否显示的标记
  private dialogFormVisible: boolean = false;

  // 所有下拉问题
  private typeOptions: any;

  // 分页插件用的属性
  private pageBean = {
    current: 1,
    size: 10,
    pages: 0, // 总页数
    total: 0, // 总记录条数
  };

  // 分页请求参数
  private pageParam = {
    data:{
      funId: "",
      name: "",
      createUser: '',
    },
    pageBean: this.pageBean,
  };

  // 分页查询
  private async selectPageData() {
    // 查询控件下拉框数据
    await this.getControlTypeList();

    const myuser: any = await this.common.getMyuser();
    this.pageParam.data.createUser = myuser.id;
    const result = await this.model.selectPageData(this.pageParam);
    if (result != null) {
      let tableDataTemp = result.data.records;
     
      for (let item in tableDataTemp){
        let name = await this.getNameByCode(tableDataTemp[item].type);
        tableDataTemp[item].typeName = name;
      }

      this.tableData = tableDataTemp;
      this.pageBean.pages = result.data.pages;
      this.pageBean.total = result.data.total;
    }
  }

  // 分页组件的值修改后，会调用该方法
  private async pageChange(data: any) {
    this.pageBean = data;
    this.selectPageData();
  }

  // 查询控件下拉框数据
  private async getControlTypeList(){
    if (this.typeOptions!=null && this.typeOptions.length>0) {
      return ;
    }
    const param = {
      data:{
        type: 'controlType',
      },
      pageBean: {
        current: 1,
        size: 100
      }
		};
		const result = await this.model.selectDictPageData(param);
    
		this.typeOptions = result.data.records;
  }

  // 先检查顺序号是否错误，错误后端会纠正
  private async queryOrderIsBad(){
    debugger;
    const param = {
      id: this.pageParam.data.funId
    };
		const result = await this.model.queryOrderIsBad(param);
    if(result.code){
      if(result.data){
        Vue.prototype.$message.success(result.data);
        
        // 刷新当前页面
        this.selectPageData();
        return true;
      }
      return false;
    }else{
      return false;
    }
  }

  // 排序，靠前
  private async updateOrderNoGoFront(id: string){
    const flag : any = await this.queryOrderIsBad();
    if(flag){
      return ;
    }

    const param = {
      id: id
    };
		const result = await this.model.updateOrderNoGoFront(param);
    if(result.code){
      Vue.prototype.$message.success("操作成功");
      this.selectPageData();
    }
  }

  // 排序，靠后
  private async updateOrderNoGoAfter(id: string){
    const flag : any = await this.queryOrderIsBad();
    if(flag){
      return ;
    }

    const param = {
      id: id
    };
		const result = await this.model.updateOrderNoGoAfter(param);
    if(result){
      Vue.prototype.$message.success("操作成功");
      this.selectPageData();
    }
  }

  

  private async showDelete(id: string){
    const flag = await Vue.prototype.$confirm('确定删除吗？');
    if (flag) {
      let paramT = {
        data: {
          detailId: id
        }
      }
      const funDetailResult = await this.model.selectDetailDataByDetailId(paramT);
      if(funDetailResult.data>0){
        Vue.prototype.$message.error('不能删除，该属性有被引用，删除相关数据后才能删除');
        return ;
      } 

      const param = {
        ids: id
      };
      const result = await this.model.removeByIds(param);
      if (result) {
        Vue.prototype.$message.success('删除成功');
        this.common.recalculateCurrent(this.pageBean);
        this.selectPageData();
      } else {
        Vue.prototype.$message.error('删除失败');
      }
    }
  }

  // 根据码表code获取名称
  private async getNameByCode(code: string){
    for (let item in this.typeOptions) {
      // alert(code);
      const flag = this.typeOptions[item].code == code;
        if (flag) {
          const name = this.typeOptions[item].name;
          return name;
        }
    }
    return '';
  }

  // 弹出编辑框
  private async showUpdate(id: string) {
    await this.getControlTypeList();

    let param = {
      data:{
        id: id,
      }
    };
    const result = await this.model.getById(param);
    this.form.id = id;
		this.form.name = result.data.name;
    this.form.type = result.data.type;
    this.form.typeValue = result.data.typeValue;
    this.form.typeName = await this.getNameByCode(result.data.type);
    this.form.title = '修改';
    this.dialogFormVisible = true;
  }

 

  // 弹出新增框
	private async showNew() {
		this.getControlTypeList();
  
  	this.form.id = '';
		this.form.name = '';
		this.form.type = '';
    this.form.typeValue = '';
    this.form.title = '新增';
		this.dialogFormVisible = true;
	}

  // 跳转到上一页
  private async goHistory() {
    this.$router.go(-1);
  }

	// 保存
	private async save() {
    const myuser: any = await this.common.getMyuser();
    // 将英文逗号转为中文逗号
    const typeValue = this.form.typeValue.replace(",","，");
		const param = {
      data:{
        id: this.form.id,
        createUser: myuser.id,
        updateUser: myuser.id,
        funId: this.pageParam.data.funId,
        name: this.form.name,
        type: this.form.type,
        typeValue: typeValue,
      }
		};
		if (this.form.id) {
			await this.model.updateById(param);
		} else {
			await this.model.save(param);
		}
		
		this.dialogFormVisible = false;
		this.selectPageData();
	}

  private async mounted() {
    console.log(this.$route.query);
    const funId: any = this.$route.query.funId;
    const funName: any = this.$route.query.name;
    this.pageParam.data.funId = funId;
    this.funName = funName;
    await this.selectPageData();
  }

  // 跳转到上一页
  private async goHostory() {
    this.$router.go(-1);
  }
}
